<script>
	import { createEventDispatcher } from 'svelte';
	import { fade } from 'svelte/transition';
	import ArrowRight from './ArrowRight.html';
	import BallPulse from './BallPulse.html';

	const dispatch = createEventDispatcher();

	let mask;
	let status;
	let fields = {
		name: null,
		company: null,
		email: null,
		phone: null,
	};
	export let session;

	function handleModalClosing(e) {
		if (e.target === mask) dispatch('close');
	}

	function handleFormSubmit() {
		if (
			fields.name &&
			fields.company &&
			fields.email &&
			fields.phone &&
			session
		) {
			status = 'pending';
			const formData = new FormData();
			formData.append('input_5', session);
			formData.append('input_1', fields.name);
			formData.append('input_4', fields.company);
			formData.append('input_2', fields.email);
			formData.append('input_3', fields.phone);

			fetch(wordpress_object.download_endpoint, {
				method: 'POST',
				body: formData,
				headers: {
					'X-WP-Nonce': wordpress_object.nonce,
				},
			})
				.then((response) => {
					return response.json();
				})
				.catch((error) => console.error(error))
				.then((response) => {
					status = 'success';
					
					setTimeout(() => {
						window.location.href = wordpress_object.follow_link;
					}, 1500);
				});
		}
	}
</script>

<div
	class="modal-mask"
	transition:fade={{ duration: 250 }}
	bind:this={mask}
	on:click|stopPropagation={handleModalClosing}>
	<div class="modal-container">

		<div on:click={() => (dispatch('close'))} class="close-modal-button">
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="24px"
				height="24px"
				viewBox="0 0 24 24"
				fill="none"
				stroke="currentColor"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round">
				<line x1="18" y1="6" x2="6" y2="18" />
				<line x1="6" y1="6" x2="18" y2="18" />
			</svg>
		</div>
		<div class="modal-header">
			<img src="" alt="" />
			<h2>Download</h2>
			<h3>Brochure: {session}</h3>
			<hr />
			{#if !status}
				<form on:submit|preventDefault={handleFormSubmit}>
					<div class="form-group">
						<input
							type="text"
							placeholder="Naam *"
							bind:value={fields.name}
							required />
					</div>
					<div class="form-group">
						<input
							type="text"
							placeholder="Bedrijfsnaam *"
							bind:value={fields.company}
							required />
					</div>
					<div class="form-group">
						<input
							type="email"
							placeholder="E-mailadres *"
							bind:value={fields.email}
							required />
					</div>
					<div class="form-group">
						<input
							type="text"
							placeholder="Telefoonnummer *"
							bind:value={fields.phone}
							required />
					</div>
					<div class="form-footer">
						<button>
							download brochure
						</button>
					</div>
				</form>
			{:else if status === 'pending'}
				<div class="loading-spinner">
					<BallPulse />
				</div>
			{:else}
				<h3 class="confirmation">
					Bedankt voor de aanvraag!
					<br />
					U ontvangt de download per mail
				</h3>
			{/if}
		</div>
	</div>
</div>
